import GroupEdit from 'app/user/group/GroupEdit';
import useStylesForm from 'common/components/styles/useStylesForm.styles';
import { useSelector } from 'react-redux';
import { getUser } from 'redux/slices/authSlice';
import 'suneditor/dist/css/suneditor.min.css';
import { useStylesMyAccount } from './styles/useStylesMyAccount';

const GroupManagementForm = () => {
    const { classes: classes1 } = useStylesForm();
    const { classes: classes2, cx } = useStylesMyAccount();
    const classes = { ...classes1, ...classes2 };
    const user = useSelector(getUser);

    return (
        <div className={classes.root}>
            <div className={cx(classes.container, classes.scroll)}>
                <div className={cx(classes.body, classes.mW80)}>
                    <GroupEdit group={{ id: user.userGroupId }} isProfile={true} />
                </div>
            </div>
        </div>
    );
};

export default GroupManagementForm;
